// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import IsUsernameAvailableForShopRequestModel from '../../model/is-username-available-for-shop-request-model';
import IsUsernameAvailableForShopRequestDTO from '../dto/is-username-available-for-shop-request-dto';
import dtoSchema from '../schemas/is-username-available-for-shop-request-schema';

export default abstract class IsUsernameAvailableForShopRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<IsUsernameAvailableForShopRequestDTO>) {
    super();
    if (data) {
      this.username = data.username;
    }
  }
  /**
  */
  username?: string;

  static toModel(dto: DeepPartial<IsUsernameAvailableForShopRequestDTO>): IsUsernameAvailableForShopRequestModel;
  static toModel(dto: DeepPartial<IsUsernameAvailableForShopRequestDTO> | undefined | null): IsUsernameAvailableForShopRequestModel | undefined;
  static toModel(dto: DeepPartial<IsUsernameAvailableForShopRequestDTO> | undefined | null): IsUsernameAvailableForShopRequestModel | undefined {
    return dto ? new IsUsernameAvailableForShopRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<IsUsernameAvailableForShopRequestModel> | IsUsernameAvailableForShopRequestModel): IsUsernameAvailableForShopRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      username: unwrapped.username,
    } as IsUsernameAvailableForShopRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for IsUsernameAvailableForShopRequestModel, can not map to IsUsernameAvailableForShopRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
